import React from 'react';

const steps = [
    {
        number: '01',
        title: 'Design & detailing',
        text: 'We design sophisticated construction facades and prepare the detailing that turns an architectural brief into a buildable system.',
    },
    {
        number: '02',
        title: 'Fabrication',
        text: 'Two glazing lines support a daily production capacity of up to 4000 sq.ft., so large-scale work can move through the shop with consistent quality.',
    },
    {
        number: '03',
        title: 'Site installation',
        text: 'Experienced teams install glazing, cladding, windows, doors, railing, clean-room systems, canopies, and skylights on site.',
    },
    {
        number: '04',
        title: 'Turnkey handover',
        text: 'We close the project as a turnkey solution, using glass, steel, aluminium, and modern materials to match the design intent.',
    },
];

const HProficiency = () => {
    return (
        <section className="page-section process-section" id="proficiency">
            <div className="container">
                <div className="section-intro reveal">
                    <p className="eyebrow">How we work</p>
                    <h2 className="section-title">From design to final fitting</h2>
                    <p>
                        Design, fabrication and site installation for glazing and facade work, carried through to handover.
                    </p>
                </div>
                <div className="row g-4">
                    {steps.map((step, index) => (
                        <div className="col-md-6 col-lg-3" key={step.number}>
                            <article className="process-card tilt-3d reveal" style={{ transitionDelay: `${index * 90}ms` }}>
                                <span>{step.number}</span>
                                <h3>{step.title}</h3>
                                <p>{step.text}</p>
                            </article>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HProficiency;
